import React from "react";

class FormElement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.initialValue ? this.props.initialValue : "",
            name: this.props.name
        };
        this.handleChange = this.handleChange.bind(this);
        // this.makeCustomProps(this.props);
    }
    // makeCustomProps(props){
    //     this.customProps = Object.assign({},props);
    //     this.customProps["validator"] && delete this.customProps["validator"];
    // }
    handleChange(event, value) {
        var eVal = value !== undefined ? value : event.target.value;
        this.props.onChangeEvent && this.props.onChangeEvent.call(this.props.context, event);
        this.setState({ value: eVal });
        this.validate(eVal);
    }
    componentWillReceiveProps(props){
        props.value && this.setState({
            value:props.value
        });
    }
    validate(v){
        if(this.props._formElementStatuschange && this.props.validator){
            this.props._formElementStatuschange(this.props.validator(v),this.state.name);
        }
    }
}

export default FormElement;
